var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.076,18.984H0v-2H17.076V0h2Z","transform":"translate(0 13.489) rotate(-45)","fill":"#d7b368"}));
}

ArrowRight.defaultProps = {"width":"26.913","height":"26.913","viewBox":"0 0 26.913 26.913"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
